import { enrichQuotesWithROI } from '@client/util/enrichQuotesWithROI';
import { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import { postLtcPlanningQuotesQueryResponse } from './ltcPlanningQuotesModel';
import type { Quote } from './quotesModel';
import { AppState } from './store';

/**
 * Middleware that intercepts LTC planning quotes responses and enriches them with ROI calculations
 * This ensures ROI is calculated once when quotes are fetched, not on every render
 */
function enrichLtcPlanningQuotesMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  // Check if this is a quotes response action
  if (action.type === postLtcPlanningQuotesQueryResponse.type) {
    const state = getStore();
    const client = state.client.data;
    const quotesPayload = (action as any).payload as Quote[];

    if (!client || !quotesPayload?.length) {
      // No client or no quotes, pass through unchanged
      next(action);
      return;
    }

    try {
      // Enrich quotes with ROI calculations using shared utility
      const enrichedQuotes = enrichQuotesWithROI(quotesPayload, client, 'total', {
        handleTraditionalLTC: true,
      });

      // Dispatch the enriched quotes instead of the original payload
      next({
        ...action,
        payload: enrichedQuotes,
      });
    } catch (error) {
      console.error('[enrichLtcPlanningQuotesMiddleware] Error enriching quotes:', error);
      // On error, pass through original action
      next(action);
    }
  } else {
    // Not a quotes response, pass through
    next(action);
  }
}

export const enrichLtcPlanningQuotesMiddleware = createSimpleMiddleware(
  enrichLtcPlanningQuotesMiddlewareImpl,
);
